import styled from 'styled-components';

export const SkillsContainer = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-top: 30px;
`;

export const Title = styled.h1`
	color: #8f3d8f;
	margin: 30px 0;
`;

export const Subtitle = styled.h4`
	color: #8f3d8f;
`;

export const TextContainer = styled.div`
	width: 60%;
	text-align: justify;
`;

export const List = styled.ul`		
	text-decoration: none;
	margin-top: 30px;
	margin-left: 10px;
`;

export const Container = styled.div`
	display: flex;
	justify-content: space-between;
`;

export const ListContainer = styled.div`
	padding: 30px;
	text-align: start;
`;